import { Pill } from "@/components/atoms/Pill/Pill";
import CheckboxGroup, { type CheckboxGroupItem } from "@/components/molecules/CheckboxGroup/CheckboxGroup";
import { ChipGroup } from "@/components/molecules/ChipGroup/ChipGroup";
import { DropdownMenu } from "@/components/molecules/DropdownMenu/DropdownMenu";
import type { SelectedId } from "@/components/molecules/MultiSelectDropdown/MultiSelectDropdownView/type";
import { t } from "@lingui/core/macro";
import { useRef } from "react";
import "./MultiSelectDropdownView.scss";

type ViewProps = {
  items: CheckboxGroupItem[];
  isOpen: boolean;
  setOpen: (v: boolean) => void;
  isChecked: (id: SelectedId) => boolean;
  toggle: (id: SelectedId) => void;
  placeholder?: string;
  disabled?: boolean;
  showPillsBelow?: boolean;
};

export function MultiSelectDropdownView({
  items,
  isOpen,
  setOpen,
  isChecked,
  toggle,
  placeholder = "Select…",
  disabled,
  showPillsBelow = false,
}: ViewProps) {
  const anchorRef = useRef<HTMLDivElement>(null);
  const selected = items.filter((i) => isChecked(i.id));
  return (
    <div className="msd">
      <div
        ref={anchorRef}
        className={`msd__button ${disabled ? "is-disabled" : ""}`}
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          !disabled && setOpen(!isOpen);
        }}
      >
        <div className="msd__button-text">
          {selected.length ? (
            <span className="msd__placeholder">{t`Select...`}</span>
          ) : (
            <span className="msd__placeholder">{placeholder}</span>
          )}
        </div>
        <span className="msd__count">{selected.length}</span>
        <span className={`msd__caret ${isOpen ? "is-open" : ""}`} aria-hidden>
          ▾
        </span>
      </div>
      {showPillsBelow && (
        <ChipGroup>
          {selected.length
            ? selected.map((i) => (
                <Pill
                  key={String(i.id)}
                  onClick={(e) => {
                    toggle(i.id);
                  }}
                >
                  {i.label}
                </Pill>
              ))
            : null}
        </ChipGroup>
      )}

      <DropdownMenu
        isOpen={isOpen}
        onClose={() => {
          setOpen(false);
        }}
        anchorRef={anchorRef}
        placement="bottom-start"
      >
        <li>
          <CheckboxGroup items={items.map((i) => ({ ...i, isChecked: isChecked(i.id) }))} onClick={toggle} />
        </li>
      </DropdownMenu>
    </div>
  );
}
